/**
 * Fragmentos de classe compartilhados pelo ui-kit.
 *
 * Existem para que altura de campo, anel de foco e raio sejam decididos em UM
 * lugar. Antes a mesma string de input aparecia 112 vezes no app, o botão
 * primário 55 e o card 77 — e já divergiam entre si (Login com py-2.5, o resto
 * com py-2; três "secundários" diferentes entre Checkout, PDV e Frente de Caixa).
 */

/* Anel de foco único do sistema. `data-ring` desliga o piso global do index.css,
   porque aqui o anel é desenhado à mão. */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 focus-visible:ring-offset-1 focus-visible:ring-offset-white";

/* Variante do anel para superfícies escuras (sidebar navy, hero, rodapé). */
export const FOCUS_RING_DARK =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-1 focus-visible:ring-offset-transparent";

/**
 * Alturas de controle.
 *
 * `md` (40px) é o padrão — os 38px de antes ficavam abaixo do confortável e a
 * diferença é imperceptível no layout. `lg` (44px) atende o mínimo de alvo de
 * toque do WCAG 2.5.5 e é o padrão em telas de balcão/tablet. `sm` só para
 * tabelas densas em desktop.
 *
 * O texto começa em 16px e só encolhe a partir de `md:` (768px). Abaixo disso,
 * fonte menor que 16px faz o Safari do iPhone ampliar a tela ao focar o campo,
 * e ele não volta sozinho. O piso em `index.css` cobre os campos fora do kit;
 * aqui a regra fica visível para quem lê o sistema, não só no efeito.
 */
export const CONTROL_SIZE = {
  sm: "h-8 text-base md:text-xs",
  md: "h-10 text-base md:text-sm",
  lg: "h-11 text-base md:text-sm",
  xl: "h-12 text-base",
};

/** Superfície padrão de conteúdo. */
export const SURFACE = "bg-white border border-slate-200 rounded-xl";

/** Rótulo em caixa alta (era `text-[10px]/[11px] font-semibold tracking-... uppercase`). */
export const EYEBROW = "text-eyebrow uppercase text-slate-500";

export const DISABLED = "disabled:opacity-50 disabled:cursor-not-allowed";
